import { useModals } from '@/components/modals/ModalProvider';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { SiteReport } from '@/libs/fleet-api/services/types';
import { Button, Col, Divider, Form, Input, Row } from 'antd';
import { FC } from 'react';
import { useFRMSiteVisitReportPage } from './SiteReportPage';

export const useFRMSiteVisitReportDetailForm = () => {
	return useForm<SiteReport<'payload'>>();
};

const FRMSiteVisitReportDetailForm: FC = () => {
	const { openMapModal } = useModals();
	const { query, siteReportDetailForm } = useFRMSiteVisitReportPage();
	const { form, value, fieldName } = siteReportDetailForm;
	const { siteReport, surveyInformation } = query.data?.data ?? {};

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			name="siteReport"
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					visitPurpose: siteReport?.visitPurpose,
					visitSiteAddress:
						siteReport?.visitSiteAddress ?? surveyInformation?.siteAddress,
					visitSiteLat: siteReport?.visitSiteLat ?? surveyInformation?.siteLat,
					visitSiteLong:
						siteReport?.visitSiteLong ?? surveyInformation?.siteLong,
					visitLocationAnalysis: siteReport?.visitLocationAnalysis,
					additionalVisitInfo: siteReport?.additionalVisitInfo,
					actionPlan: siteReport?.actionPlan,
				} as SiteReport<'payload'>
			}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('visitPurpose')}
				label="Tujuan Kunjungan"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required('Tujuan Kunjungan wajib diisi')]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				label="Lokasi Kunjungan"
				labelCol={{
					span: 6,
				}}
			>
				<Form.Item
					name={fieldName('visitSiteAddress')}
					noStyle
					rules={[rule.required('Lokasi Kunjungan wajib diisi')]}
				/>
				<Form.Item
					name={fieldName('visitSiteLat')}
					noStyle
				/>
				<Form.Item
					name={fieldName('visitSiteLong')}
					noStyle
				/>
				<Row
					gutter={10}
					align="middle"
				>
					<Col flex="auto">
						<Input
							disabled
							value={value?.visitSiteAddress}
						/>
					</Col>
					<Col flex="none">
						<Button
							type="link"
							onClick={() => {
								openMapModal({
									title: 'Lokasi Kunjungan',
									address: value?.visitSiteAddress,
									latitude: value?.visitSiteLat,
									longitude: value?.visitSiteLong,
									onChange: ({ address, center }) => {
										form.setFieldsValue({
											visitSiteAddress: address,
											visitSiteLat: center.lat,
											visitSiteLong: center.lng,
										});
									},
								});
							}}
						>
							<u>Edit Lokasi Kunjungan</u>
						</Button>
					</Col>
				</Row>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('visitLocationAnalysis')}
				label="Analisa Lokasi Kunjungan"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required('Analisa Lokasi Kunjungan wajib diisi')]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalVisitInfo')}
				label="Informasi Lainnya"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required('Informasi Lainnya wajib diisi')]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
		</Form>
	);
};

export default FRMSiteVisitReportDetailForm;
